import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';


const configUrl = '/assets/data/config.json';


async function loadConfig(): Promise<any> {

  const response = await fetch(configUrl, {
    cache: 'no-cache'
  });

  if (!response.ok) {
    throw new Error(
      `Unable to load config.json: ${response.status}`
    );
  }

  return response.json();
}


async function bootstrap(): Promise<void> {

  try {

    // =========================================
    // 1. Load runtime configuration
    // =========================================

    const config = await loadConfig();


    // =========================================
    // 2. Apply runtime configuration
    // =========================================

    environment.production =config.production;

    environment.cookieDomain = config.cookieDomain;

    environment.API_BASE_PATH =config.API_BASE_PATH;

    environment.socketUrl = config.socketUrl;

    environment.Checkin_BASE_PATH =config.Checkin_BASE_PATH;

    environment.API_BASE_PATH_Hq = config.API_BASE_PATH_Hq;

    environment.ImageBasePath = config.ImageBasePath;

    environment.HA_API_BASE_PATH = config.HA_API_BASE_PATH;

    environment.blogBaseUrl = config.blogBaseUrl;

    environment.adminUrl = config.adminUrl;

    environment.customDropdownApiUrl = config.customDropdownApiUrl;

    environment.blogImageBasePath = config.blogImageBasePath;

    environment.keyrefreshlimit = config.keyrefreshlimit;

    environment.version = config.version;

    environment.version_message = config.version_message;


    // =========================================
    // 3. Production mode
    // =========================================

    if (environment.production) {
      enableProdMode();
       if (environment.production) {
          console.log = () => { };
          console.warn = () => { };
          console.error = () => { };
        }
    }


    // =========================================
    // 4. Version check
    // =========================================

    const oldVersion =
      localStorage.getItem('appVersion');


    if (oldVersion && oldVersion !== environment.version) {

      const reload = confirm(environment.version_message);

      localStorage.setItem('appVersion',environment.version);

      if (reload) {
        await hardReload();
        return;
      }

    } else {
      localStorage.setItem(
        'appVersion',
        environment.version
      );
    }


    // =========================================
    // 5. Bootstrap Angular
    // =========================================

    await platformBrowserDynamic()
      .bootstrapModule(AppModule);

  } catch (error) {

    console.error(
      'Failed to start application:',
      error
    );

    document.body.innerHTML = `
      <div style="
        padding:40px;
        font-family:Arial;
        text-align:center;
      ">
        <h2>Unable to start application</h2>
        <p>Please refresh the page.</p>
      </div>
    `;
  }
}


// =============================================
// Start application
// =============================================

bootstrap();


async function hardReload(): Promise<void> {

  // Only used when application version changes

  if ('caches' in window) {

    const cacheKeys =
      await caches.keys();

    await Promise.all(
      cacheKeys.map(key =>
        caches.delete(key)
      )
    );
  }


  if ('serviceWorker' in navigator) {

    const registrations =
      await navigator.serviceWorker
        .getRegistrations();

    await Promise.all(
      registrations.map(
        registration =>
          registration.unregister()
      )
    );
  }


  window.location.reload();
}